import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const TackForetag = lazy(() => import("@/pages/info/TackForetag"));

export const Route = createFileRoute("/tack-foretag")({
  head: () =>
    seoHead("/tack-foretag", {
      description:
        "Vi har tagit emot din förfrågan. En företagsansvarig återkommer inom 1 arbetsdag.",
      // Tacksidan nås bara efter ett formulär – den ska inte indexeras.
      noindex: true,
    }),
  component: () => <TackForetag />,
});
